module.exports = __webpack_public_path__ + "img/bg.d07e9fe3.png";